import React, {Component, Fragment} from 'react';
import "./ImageSliderQuotation.css";
import SliderContent1 from "./SliderQuotationContent1/SliderQuotationContent1";
import SliderContent2 from "./SliderQuotationContent2/SliderQuotationContent2";
import SliderContent3 from "./SliderQuotationContent3/SliderQuotationContent3";
import {FormattedMessage} from "react-intl";

const ContentComponent = (props) => {
    if(props.content === 1){
        return(
            <Fragment>
                <SliderContent1/>
            </Fragment>
        )
    }
    else if(props.content === 2){
        return (
            <Fragment>
                <SliderContent2/>
            </Fragment>
        )
    }else{
        return (
            <Fragment>
                <SliderContent3/>
            </Fragment>
        )
            }
};

class ImageSliderQuotation extends Component {
    constructor(props){
        super(props);
        this.state = {
            content : 1
        };
        this.handleChangeContent = this.handleChangeContent.bind(this);
    };

    handleChangeContent = (content) => {
       this.setState({
           content
       })

    };
    render(){

        let content1Background = "content1-background font-color-inactive";
        let content2Background = "content2-background font-color-inactive";
        let content3Background = "content3-background font-color-inactive";
        if(this.state.content === 1){
            content1Background = "content1-background-onclick font-color-active";
        }
        else if(this.state.content === 2){
            content2Background = "content2-background-onclick font-color-active"
        }
        else{
            content3Background = "content3-background-onclick font-color-active"
        }

        return(
            <Fragment>
                <div className="col-md-12 form-height no-padding">
                    <div className="col-md-2 home-pg-form-icon no-padding">
                        <div className={"col-md-12 link-height-top no-padding "+content1Background} onClick={()=>this.handleChangeContent(1)}>
                            <FormattedMessage id="app.navigation-quotation.content1"
                                              defaultMessage="Substrate Manufacturing Estimate"
                                              description=""/>
                        </div>
                        <div className={"col-md-12 link-height reduced-content no-padding "+content2Background} onClick={()=>this.handleChangeContent(2)}>
                            <FormattedMessage id="app.navigation-quotation.content2"
                                              defaultMessage="Metal Mask Manufacturing Estimate"
                                              description=""/>
                        </div>
                        <div className={"col-md-12 link-height-bottom no-padding "+content3Background} onClick={()=>this.handleChangeContent(3)}>
                            <FormattedMessage id="app.navigation-quotation.content3"
                                              defaultMessage="Production Specification"
                                              description=""/>
                        </div>
                    </div>
                    <div className="col-md-10 text-color-green">
                        <ContentComponent content = {this.state.content}/>
                    </div>
                </div>
            </Fragment>
        );
    }

}

export default ImageSliderQuotation;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/ImageSlider/ImageSliderQuotation/ImageSliderQuotation.js